import { render, staticRenderFns } from "./consumed.vue?vue&type=template&id=a276829e&scoped=true"
import script from "./consumed.vue?vue&type=script&lang=js"
export * from "./consumed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a276829e",
  null
  
)

export default component.exports